import React from 'react';
import { Link } from 'react-scroll';

function Logo() {
    return (
        <Link to="home" smooth={true} duration={500} className="cursor-pointer">
            <div className="flex items-center text-cream">
                <div className="mr-2">
                    <img
                        src="/logo2.png"
                        alt="PlatypusBox Logo"
                        className="w-10 h-10 object-contain"
                    />
                </div>
                <span className="text-xl font-display tracking-wider">PLATYPUSBOX</span>
            </div>
        </Link>
    );
}

export default Logo;
